export const DEFAULT_LOGO = '/assets/yournextu-logo-v2.svg';
